var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{staticClass:"gl-mt-0",attrs:{"title":_vm.$options.i18n.title,"svg-path":_vm.emptyStateSvgPath,"primary-button-link":_vm.$options.DOC_PATH_SECURITY_CONFIGURATION,"primary-button-text":_vm.$options.i18n.primaryButtonText,"description":_vm.$options.i18n.description}})
}
var staticRenderFns = []

export { render, staticRenderFns }